import { render, staticRenderFns } from "./UploadedFilesEditModal.vue?vue&type=template&id=63fa16e3&scoped=true&"
import script from "./UploadedFilesEditModal.vue?vue&type=script&lang=ts&"
export * from "./UploadedFilesEditModal.vue?vue&type=script&lang=ts&"
import style0 from "./UploadedFilesEditModal.vue?vue&type=style&index=0&id=63fa16e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fa16e3",
  null
  
)

export default component.exports